var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import T, { addTranslations } from '../../Utils/Locale';
import { getGlobalState } from '../../Utils/GlobalState';
import fetchRecaptchaToken from '../../Utils/FetchRecaptchaToken';
import AuthenticationCreateFormInformation from './AuthenticationCreateFormInformation';
import AuthenticationCreateFormConsents from './AuthenticationCreateFormConsents';
import AuthenticationPartnerSelect from './AuthenticationPartnerSelect';
import translations from './translations/create-form.yml';
import { modalId } from './constants';
addTranslations(translations);
const PAGE = {
    PARTNER: 'partner',
    INFORMATION: 'information',
    CONSENTS: 'consents',
    VALIDATION: 'validation'
};
const AuthenticationCreateForm = ({ phoneRequired, partner = null, onLoginClick, onBack, onFinish, showSelectPartner = false, showPartnerConsents = false }) => {
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [user, setUser] = useState({});
    const [page, setPage] = useState(showSelectPartner ? PAGE.PARTNER : PAGE.INFORMATION);
    return (_jsxs("div", Object.assign({ className: 'flex flex-col' }, { children: [page === PAGE.PARTNER && showSelectPartner && (_jsx(AuthenticationPartnerSelect, { onClickNext: handleClickSelectPartnerNext })), page === PAGE.INFORMATION && (_jsx(AuthenticationCreateFormInformation, { updateUser: (information) => {
                    setUser(Object.assign(Object.assign({}, user), information));
                    handleChangePage(PAGE.CONSENTS);
                }, user: user, errors: errors, phoneRequired: phoneRequired, onGoBack: showSelectPartner ? () => setPage(PAGE.PARTNER) : null })), page === PAGE.CONSENTS && (_jsx(AuthenticationCreateFormConsents, { updateUser: (information) => {
                    const newUser = Object.assign(Object.assign({}, user), information);
                    setUser(newUser);
                    createUser(newUser);
                }, errors: errors, acceptedMarketing: user.marketing === '1', isLoading: loading, goBack: () => handleChangePage(PAGE.INFORMATION), showPartnerConsents: showPartnerConsents, partner: partner })), page === PAGE.VALIDATION ? _jsx("p", { children: T('authentication.create.validation') }) : null, _jsx("div", Object.assign({ className: 'flex flex-col justify-center items-center mb-12 md:mb-5' }, { children: onLoginClick && (_jsx(_Fragment, { children: _jsxs("span", Object.assign({ className: 'text-dark-teal self-center font-medium text-xs mt-4' }, { children: [T('authentication.create.existing'), _jsx("button", Object.assign({ type: 'button', onClick: onLoginClick, className: 'tailwind-reset underline ml-1 text-dark-teal self-center font-medium text-xs' }, { children: T('authentication.create.authenticate') }))] })) })) })), onBack && (_jsx("button", Object.assign({ type: 'button', className: 'tailwind-reset', onClick: onBack }, { children: T('authentication.create.back') })))] })));
    function createUser(userToSave) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            setLoading(true);
            setErrors({});
            const token = yield fetchRecaptchaToken();
            let data = Object.assign(Object.assign({}, userToSave), { token });
            if (partner != null) {
                data = Object.assign(Object.assign({}, data), { partner });
            }
            try {
                const applicationUrl = getGlobalState('application_url');
                const response = yield axios.post(`${applicationUrl}/api/user/create`, data, { withCredentials: true });
                if (response.status === 208) {
                    handleChangePage(PAGE.VALIDATION);
                }
                else if (onFinish) {
                    onFinish();
                }
                else {
                    window.location.href = response.data;
                }
            }
            catch (error) {
                const errorResult = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data;
                if (errorResult != null && (errorResult === null || errorResult === void 0 ? void 0 : errorResult.element) != null) {
                    setErrors({ [errorResult.element]: errorResult.error });
                }
                else {
                    setErrors({ name: T('authentication.create.errors.unknown') });
                }
                handleChangePage(PAGE.INFORMATION);
                setLoading(false);
            }
        });
    }
    function handleClickSelectPartnerNext() {
        handleChangePage(PAGE.INFORMATION);
    }
    function handleChangePage(name) {
        setPage(name);
        const modalElement = document.getElementById(modalId);
        if (modalElement)
            modalElement.scrollTo(0, 0);
    }
};
AuthenticationCreateForm.propTypes = {
    phoneRequired: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.number
    ]).isRequired,
    partner: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool
    ]),
    onLoginClick: PropTypes.func,
    onFinish: PropTypes.func,
    onBack: PropTypes.func,
    showSelectPartner: PropTypes.bool,
    showPartnerConsents: PropTypes.bool
};
export default AuthenticationCreateForm;
